import { Cliente } from '../../comum/modelos/cliente';
import { ClienteService } from './../cliente.service';
import { Component, OnInit, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'angular2-cookie/core';

@Component({
  selector: 'app-selecao-clientes',
  templateUrl: './selecao-clientes.component.html',
  styleUrls: ['./selecao-clientes.component.css']
})
export class SelecaoClientesComponent implements OnInit {

  public clientes: Cliente[];
  public idCliente: number;
  public loading = false;

  constructor(private _clienteService: ClienteService,
    private _cookieService: CookieService,
    private router: Router) {
    this.clientes = new Array<Cliente>();
  }

  ngOnInit() {
    this.loading = true;
    this._clienteService.obterClientesHttp()
      .subscribe((clientes: Cliente[]) => {
        this.clientes = clientes;
        this.loading = false;
      });
  }

  selecionarCliente(): void {
    this._cookieService.put('idCliente', JSON.parse(JSON.stringify(this.idCliente)));
    this._cookieService.putObject('cliente', this.clientes.find(x => x.idCliente.toString() === this.idCliente.toString()));
    this.router.navigate(['']);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/cliente/selecao-clientes/selecao-clientes.component.ts